import { Component, EventEmitter, Input, Output } from '@angular/core';

/*
// example of usage
// main page wrapper for handler click on the page - we need to close all dropdown if click outside
// global closing handled in app click handler

<div (click)="clickInsideComponent($event, commonParent)" #commonParent>

<sn-dropdown-list
  [commonParent]="commonParent"
  [data]="document"
  [optionsList]="[
    {actionName:'edit',        title:'Edit Template'},
    {actionName:'annotations', title:'Salesforce Annotations'},
    {actionName:'pushback',    title:'Salesforce Data Binding'}
]"
  (clickHandler)="ParentHandler($event)" >
</sn-dropdown-list>


ParentHandler({selectedOption, data: givenDataType}) {
*/

@Component({
  selector: 'sn-dropdown-list',
  templateUrl: './dropdown-list.component.html',
  styleUrls: ['./dropdown-list.component.sass']
})
export class DropdownListComponent {
  @Output() clickHandler = new EventEmitter<{ selectedOption: string; data: any }>();
  @Input() commonParent: HTMLElement;
  @Input() optionsList: [{ title: string; actionName: string }];
  @Input() data: any;
  @Input() width = '165px';

  /**
   *
   * @param elem - target dropdown button
   * @param commonParent - wrapper tag where we will close other opened dropdown
   */
  static toggleDropdownAndCloseOther(elem: HTMLElement, commonParent: HTMLElement) {
    const allActions = commonParent.querySelectorAll('.sn-dropdown__body');

    for (let i = 0; i < allActions.length; i++) {
      if (allActions[i] !== elem) {
        allActions[i].classList.remove('sn-one-open');
      }
    }

    elem.classList.toggle('sn-one-open');
  }

  toggleDropdown(elem: HTMLElement, commonParent: HTMLElement) {
    DropdownListComponent.toggleDropdownAndCloseOther(elem, commonParent);
  }

  handleClick($event: Event, data) {
    const target = $event.target as HTMLElement;
    const selectedOption = target.getAttribute('data-action-name') || '';
    this.clickHandler.emit({ selectedOption, data });
  }
}
